import { getKnovioPresentationUrl } from '../../../../../../infrastructure/utils/knovio.utils';
import { EmbedCodeLinkViewModel } from './embed-code-link.viewmodel';

export class KnovioLinkViewModel extends EmbedCodeLinkViewModel {
    public static matchesKnovioPresentationUrl(url: string): boolean {
        return KnovioLinkViewModel.isValidUrl(url) && url.startsWith(KnovioLinkViewModel.knovioLinkPrefix);
    }

    public static getKnovioLinkById(id: string): string {
        return id ? KnovioLinkViewModel.knovioLinkPrefix + id : '';
    }

    public static readonly knovioLinkPrefix: string = getKnovioPresentationUrl();

    protected get linkPrefix(): string {
        return KnovioLinkViewModel.knovioLinkPrefix;
    }
}
